import { Tooltip } from "../ui";
import { QeddyIcon } from "./QeddyIcon";

const qeddyLauncherIconSize = 32;

export type QeddyUiState = "hidden" | "ready" | "disabled";

export type QeddyLauncherLabels = {
  open: string;
  unavailable: string;
};

export type QeddyLauncherProps = {
  state: QeddyUiState;
  labels: QeddyLauncherLabels;
  disabledTooltip?: string | null;
  onOpen: () => void;
};

export function QeddyLauncher({ state, labels, disabledTooltip, onOpen }: QeddyLauncherProps) {
  if (state === "hidden") return null;
  const disabled = state !== "ready";
  const title = disabled ? disabledTooltip || labels.unavailable : labels.open;

  return (
    <Tooltip title={title}>
      <span style={{ display: "inline-flex" }}>
        <button
          type="button"
          className="mq-frame-help"
          disabled={disabled}
          aria-label={title}
          data-qeddy-state={state}
          title={title}
          onClick={disabled ? undefined : onOpen}
        >
          <QeddyIcon size={qeddyLauncherIconSize} disabled={disabled} />
        </button>
      </span>
    </Tooltip>
  );
}
